module.exports = __webpack_public_path__ + "static/media/arrow-down.0ad361c9.svg";